import React from "react";

import {
  Box,
  Typography,
  Paper
} from "@mui/material";



function ReportCard({

  title,

  value,

  icon

}) {


return (

<Paper

sx={{

height:110,

padding:"16px 18px",

borderRadius:"14px",

border:"1px solid",

borderColor:"divider",

bgcolor:"background.paper",

boxShadow:"0 2px 8px rgba(15,23,42,0.08)",

display:"flex",

alignItems:"center",

justifyContent:"space-between"

}}

>



{/* LEFT CONTENT */}

<Box>


<Typography

sx={{

fontSize:"14px",

fontWeight:600,

color:"#52627a",

lineHeight:1.2,

fontFamily:"Inter, Roboto, Arial, sans-serif"

}}

>

{title}

</Typography>





<Typography

sx={{

fontSize:"32px",

fontWeight:700,

color:"text.primary",

marginTop:"8px",

lineHeight:1,

fontFamily:"Inter, Roboto, Arial, sans-serif"

}}

>

{value}

</Typography>



</Box>








{/* ICON RIGHT */}


<Box

sx={{

width:"52px",

height:"52px",

borderRadius:"50%",

background:"#eef4ff",

display:"flex",

alignItems:"center",

justifyContent:"center",

fontSize:"26px"

}}

>

{icon}

</Box>






</Paper>


);


}


export default ReportCard;